module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "chap4"
    }
  }, [_vm._v("Sur La Plage")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("DUCKY YOU ARE SO PRETENSUOUS! LOVE, SUNNY")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I think the word is “pretentious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("IT TAKES 1 to KNOW 1, MAGGIE.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It’s just French. Okay, here, in English:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("At the Beach")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Are you happy now?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dawn wuz here")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("That’s a sunset!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("DEPENDS ON THE WAY YOU LOOK AT IT!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You girls are wild.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Please keep your suntan oil OFF the page. And your fruit juice!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I should NOT have brought this "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("PRIVATE")]), _vm._v("! journal to the beach!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I GET NO RESPECT.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("NEITHER DO I!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("10:00")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Home Alone Again")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("I guess Ted ate the spam. It’s gone and so is he.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Too bad. I’m hungry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I did not eat a thing at the diner. I was too shocked by Jay’s STUPID stunt!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I knew I shouldn’t have gone. I had a bad feeling about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I had the best time at the beach and I NEVER SHOULD HAVE LEFT!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What kind of “friend” invites you to dinner, making you think you’re going to have a 1-on-1 talk, and then shows up with 2 extra people to make it suddenly 1 on 3, but they’re both girls, 1 of which is Lisa and the other is all dressed up and made up, so it dawns on you (DUH) that it’s really supposed to be 2 on 2 and you’ve been trapped in a blind double date and now there’s no way out?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("WHAT KIND OF SNEAKY JERK OF A FRIEND WOULD DO THAT?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The friend formerly known as Jason, that’s who.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And he doesn’t have the decency to let you KNOW IN ADVANCE, so you don’t feel AMBUSHED!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Emergency. Fight or flight. THAT’S how you feel. And you can’t do either one. You just have to sit there and smile and laugh and nod and wish you were home with Ted and the spam because anything would be better than this, and Jay is running his fingers through his gelled hair all night as if he were plowing a crop, while he talks and talks and talks and talks about—what else?—HIMSELF.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Until he gets around to talking about YOU and saying what a great guy the Duckster is, really, a natural athlete who doesn’t even know his own strength, not to mention a real brain too, don’t be fooled by the wimpy haircut and Hawaiian shirt har-har.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You wanted to kill him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What could you say? He wouldn’t stop talking. You told a few dumb jokes. Some stuff about software and TV commercials and whatever, and you could tell you sounded like a total fool because the girl was just staring at you, her smile tightening by the second, and you KNOW she was thinking, “How did I get roped into a date with this turkey?” and afterward you had to drive her home because Jay hinted loudly that he and Lisa were going off in a different direction, so she and you rode silently to her house and you could tell she couldn’t wait to get out of the car AND YOU DON’T EVEN REMEMBER HER NAME!")]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("WILL")]), _vm._v(" kill him.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd97210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/v5/7chap4.vue
// module id = 81
// module chunks = 0